
import { API_TYPE } from '@umu/umu-fetch';
const BasePath = '/uapi/v1/gsa';

export const UShowApi = {
	U_SHOW_TEMPLATE_LIST: {
		url: `${BasePath}/template-list`,
		type: API_TYPE.GET,
	},
	U_SHOW_TEMPLATE_INFO: {
		url: `${BasePath}/template-info`,
		type: API_TYPE.GET,
	},
};
